/** Distinct, actionable UI for each PDF fetch failure returned by
 *  `/api/public/clients/{token}/invoice/{id}/pdf`.
 *
 *  The backend now returns one of two specific detail strings instead of
 *  silently falling back to a Xero-regenerated PDF:
 *    * `xero_scope_missing` — the connected token pre-dates the
 *      `accounting.attachments.read` scope; accountant must reconnect Xero.
 *    * `no_supplier_pdf`    — the invoice has zero attachments in Xero.
 */
export function PdfErrorState({ error, testid }) {
  const isScopeMissing = error === "xero_scope_missing";
  const isNoAttachment = error === "no_supplier_pdf";

  if (isScopeMissing) {
    return (
      <div className="p-8 text-center max-w-md mx-auto" data-testid={`${testid}-scope-missing`}>
        <p className="uppercase text-[11px] tracking-[0.2em] text-amber-700 font-medium mb-2">Re-authorise Xero</p>
        <p className="text-sm text-[#0F172A] mb-2">FLASH can't read supplier attachments yet.</p>
        <p className="text-xs text-[#475569] leading-relaxed">
          The current Xero connection was granted before attachment access was requested. Reconnect this site from the
          <span className="font-medium"> Client Directory </span> to enable supplier PDF preview.
        </p>
      </div>
    );
  }
  if (isNoAttachment) {
    return (
      <div className="p-8 text-center max-w-md mx-auto" data-testid={`${testid}-no-attachment`}>
        <p className="uppercase text-[11px] tracking-[0.2em] text-[#475569] font-medium mb-2">No supplier PDF attached</p>
        <p className="text-sm text-[#0F172A] mb-2">This transaction has no file uploaded in Xero.</p>
        <p className="text-xs text-[#475569] leading-relaxed">
          Ask the supplier to send the original invoice, then attach it to this bill in Xero — it will appear here automatically.
        </p>
      </div>
    );
  }
  return (
    <div className="p-6 text-center" data-testid={`${testid}-generic-error`}>
      <p className="text-sm text-rose-700">Could not load invoice preview: {String(error)}</p>
    </div>
  );
}
